import { Grid } from '@mui/material';
import { AppBadge } from 'shared/components/app-badge';
import { FormTextField } from 'shared/controls';
import { ICustomProduct } from 'shared/types';
import { buildCustomProductFieldNameWithIndex } from 'shared/utility';

interface ILineItemNotesProps {
  customProduct: ICustomProduct;
  editMode: boolean;
  index: number;
}
export function CustomProductLineItemNotes({ customProduct, editMode, index }: ILineItemNotesProps) {
  const buildFieldName = buildCustomProductFieldNameWithIndex<ICustomProduct>(index);
  return (
    <Grid item xs={12} lg>
      {editMode ? (
        <AppBadge invisible={!customProduct.lineItemNotes} badgeContent={'!'} fullWidth title={'Line Item Notes'}>
          <FormTextField name={buildFieldName('lineItemNotes')} label='Line Item Notes' multiline minRows={2} />
        </AppBadge>
      ) : (
        <FormTextField name={buildFieldName('lineItemNotes')} label='Line Item Notes' multiline minRows={2} disabled />
      )}
    </Grid>
  );
}
